import { attachComponentData, useApi, featureFlagsApiRef } from '@backstage/core-plugin-api';
import React from 'react';

const FeatureFlagged = (props) => {
  const { children } = props;
  const featureFlagApi = useApi(featureFlagsApiRef);
  const isEnabled = "with" in props ? featureFlagApi.isActive(props.with) : !featureFlagApi.isActive(props.without);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isEnabled ? children : null);
};
attachComponentData(FeatureFlagged, "core.featureFlagged", true);

export { FeatureFlagged };
//# sourceMappingURL=FeatureFlagged.esm.js.map
